import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import React, { Fragment, useEffect, useState } from "react";
import Loader from "react-loaders";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  Col,
  CustomInput,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import swal from "sweetalert";
import { userService } from "../../_services/user.service";
import { api } from "../../_services/api.service";

const AlternativeSettings = ({
  partnerAlternativeId,
  partnerScenarioId,
  showMainModal,
  toggleMainModal,
  reloadList,
}) => {
  const hiddenFileInput = React.useRef(null);
  const currentUser = userService.getLoggedInUser();

  let defaultAlternative = {
    partnerAlternativeID: -1,
    partnerAlternativeMetrics: [],
    partnerScenarioID: partnerScenarioId,
    partnerAlternativeName: "",
    infoLink: "",
    actionLink: "",
    cost: "",
    description: "",
  };

  let [alternative, setAlternative] = useState(defaultAlternative);
  let [isLoading, setIsLoading] = useState(false);
  let [isMetricsLoading, setIsMetricsLoading] = useState(false);
  let [metrics, setMetrics] = useState([]);
  let [showModal, setShowModal] = useState(false);
  let [metricToEdit, setMetricToEdit] = useState(null);

  let [address, setAddress] = useState("");
  let [coords, setCoords] = useState(null);

  const successToastOpts = {
    autoClose: 3000,
    type: toast.TYPE.SUCCESS,
    hideProgressBar: false,
  };

  const errorToastOpts = {
    autoClose: 3000,
    type: toast.TYPE.ERROR,
    hideProgressBar: false,
  };

  useEffect(() => {
    if (showMainModal && partnerAlternativeId > -1) {
      loadData();
    } else if (showMainModal) {
      setAlternative({
        ...defaultAlternative,
        partnerScenarioID: partnerScenarioId,
      });
    }
  }, [showMainModal, partnerAlternativeId]);

  const loadData = () => {
    loadAlternative(partnerAlternativeId);
    loadMetrics();
  };

  const loadAlternative = (id) => {
    if (id > 0) {
      setIsLoading(true);
      api.getPartnerAlternativeById(id).then((data) => {
        if (data.partnerAlternativeMetrics == undefined) {
          data.partnerAlternativeMetrics = [];
        }
        setAlternative(data);
        setIsLoading(false);
      });
    }
  };

  const loadMetrics = () => {
    setIsMetricsLoading(true);
    api.getPartnerMetricsByPartnerScenario(partnerScenarioId).then((data) => {
      setMetrics(data);
      setIsMetricsLoading(false);
    });
  };

  const handleSubmit = (e, errors, values) => {
    if (errors.length == 0) {
      alternative.cost = extractNumber(alternative.cost);
      if (alternative.partnerAlternativeID > 0) {
        api.updatePartnerAlternative(0, alternative).then((data) => {
          toast("Alternative saved successfuly", successToastOpts);
          toggleMainModal();
          reloadList();
        });
      } else {
        api.createPartnerAlternative(0, alternative).then((id) => {
          toast("Alternative saved successfuly", successToastOpts);
          toggleMainModal();
          reloadList();
        });
      }
    }
  };

  const saveAlternativeAndAddAnother = () => {
    if (alternative.partnerAlternativeID > 0) {
      api.updatePartnerAlternative(0, alternative).then((data) => {
        toast("Alternative saved successfuly", successToastOpts);
        reloadList();
        setAlternative({ ...defaultAlternative });
        setMetrics([]);
      });
    } else {
      api.createPartnerAlternative(0, alternative).then((id) => {
        toast("Alternative saved successfuly", successToastOpts);
        reloadList();
        setAlternative({ ...defaultAlternative });
        setMetrics([]);
      });
    }
  };

  const getAlternativeMetricValue = (partnerMetricId) => {
    if (alternative.partnerAlternativeMetrics == undefined) {
      return "";
    }
    let metric = alternative.partnerAlternativeMetrics.find(
      (x) => x.partnerMetricID == partnerMetricId
    );

    if (!metric) {
      return "";
    }

    return metric.partnerAlternativeMetricValue;
  };

  const removeAlternative = () => {
    swal({
      title: "",
      text: "Are you sure you want to remove this alternative?",
      icon: "warning",
      buttons: {
        ok: "Yes",
        cancel: "No",
      },
      dangerMode: true,
    }).then((val) => {
      if (val) {
        api.deletePartnerAlternative(0, alternative).then((data) => {
          toggleMainModal();
          reloadList();
        });
      }
    });
  };

  const changeMetric = (metric) => {
    metric.partnerAlternativeMetricValue = getAlternativeMetricValue(
      metric.partnerMetricID
    );
    setMetricToEdit(metric);
    setShowModal(true);
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const handleMetricSubmit = (e, errors, values) => {
    if (errors.length == 0) {
      if (
        alternative.partnerAlternativeMetrics.find(
          (x) => x.partnerMetricID == metricToEdit.partnerMetricID
        ) == undefined
      ) {
        let obj = { ...metricToEdit };
        obj.partnerAlternativeID = partnerAlternativeId;
        if (obj.partnerMetricType == "Address (Map)") {
          obj.partnerAlternativeMetricValue = address;
          obj.partnerAlternativeMetricExtraValue = `${coords.lat},${coords.lng}`;
        }
        api.createPartnerAlternativeMetric(obj).then((data) => {
          toggleModal();
          loadData();
        });
      } else {
        let pam = alternative.partnerAlternativeMetrics.find(
          (x) => x.partnerMetricID == metricToEdit.partnerMetricID
        );
        let obj = { ...metricToEdit };
        obj.partnerAlternativeMetricID = pam.partnerAlternativeMetricID;
        obj.partnerAlternativeID = partnerAlternativeId;
        if (obj.partnerMetricType == "Address (Map)") {
          obj.partnerAlternativeMetricValue = address;
          obj.partnerAlternativeMetricExtraValue = `${coords.lat},${coords.lng}`;
        }
        api.updatePartnerAlternativeMetric(0, obj).then((data) => {
          toggleModal();
          loadData();
        });
      }
    }
  };

  const handleUploadFileClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleInputFileChange = (event) => {
    const fileUploaded = event.target.files[0];
    const fileType = metricToEdit.partnerMetricType === "Document" ? 0 : 1;
    api
      .uploadFile(
        currentUser.userId,
        fileType,
        fileUploaded,
        alternative.partnerAlternativeID,
        metricToEdit.partnerMetricID
      )
      .then(
        (data) => {
          loadData();
          toggleModal();
        },
        (err) => {
          toggleModal();
          toast("Could not upload file", errorToastOpts);
        }
      );
  };

  const handleChange = (address) => {
    setAddress(address);
  };

  const handleSelect = (address) => {
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        setAddress(address);
        setCoords({ lat: latLng.lat, lng: latLng.lng });
      })
      .catch((error) => console.error("Error", error));
  };

  const extractNumber = (str) => {
    if (typeof str === "number") return str;

    if (str == null || str === undefined) return 0;

    str = str.replace(/[^\d\.]*/g, "");
    str = str.replace(/^\D+/g, "");

    return str;
  };

  return (
    <Modal
      size="lg"
      isOpen={showMainModal}
      toggle={() => toggleMainModal()}
      backdrop="static"
    >
      <ModalHeader toggle={() => toggleMainModal()}>Alternative</ModalHeader>
      <ModalBody>
        {isLoading && <Loader style={{}} type="ball-pulse" active />}
        {!isLoading && (
          <Row style={{ marginTop: "30px" }}>
            <Col md="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <AvForm onSubmit={handleSubmit}>
                    <Row>
                      <Col md="12">
                        <AvField
                          name="partnerAlternativeName"
                          label="Alternative Name *"
                          value={alternative.partnerAlternativeName}
                          onChange={(e) =>
                            setAlternative({
                              ...alternative,
                              partnerAlternativeName: e.target.value,
                            })
                          }
                          placeholder="Enter..."
                        />
                        <AvField
                          name="infoLink"
                          label="Info Link "
                          value={alternative.infoLink}
                          onChange={(e) =>
                            setAlternative({
                              ...alternative,
                              infoLink: e.target.value,
                            })
                          }
                          placeholder="Enter..."
                        />
                        <AvField
                          name="actionLink"
                          label="Action Link "
                          value={alternative.actionLink}
                          onChange={(e) =>
                            setAlternative({
                              ...alternative,
                              actionLink: e.target.value,
                            })
                          }
                          placeholder="Enter..."
                        />
                        <AvField
                          name="cost"
                          label="Cost "
                          value={alternative.cost}
                          onChange={(e) =>
                            setAlternative({
                              ...alternative,
                              cost: e.target.value,
                            })
                          }
                          placeholder="Enter..."
                        />
                        <AvField
                          name="description"
                          label="Description"
                          value={alternative.description}
                          type="textarea"
                          style={{ height: "100px" }}
                          onChange={(e) =>
                            setAlternative({
                              ...alternative,
                              description: e.target.value,
                            })
                          }
                          placeholder="Enter..."
                        />
                      </Col>
                    </Row>
                    <div>
                      <CustomInput
                        type="checkbox"
                        id="musthave"
                        checked={alternative.mustHave}
                        label="Cannot be removed by decision maker"
                        onChange={(e) =>
                          setAlternative({
                            ...alternative,
                            mustHave: !alternative.mustHave,
                          })
                        }
                      />
                    </div>
                    <div className="pull-right">
                      <Button
                        color="primary"
                        type="submit"
                        style={{ marginRight: ".25rem" }}
                      >
                        Save
                      </Button>
                      <Button
                        color="primary"
                        style={{ marginRight: ".25rem" }}
                        onClick={(e) => saveAlternativeAndAddAnother()}
                      >
                        Save and Add Another
                      </Button>
                      {alternative.partnerAlternativeID > 0 && (
                        <Button
                          color="danger"
                          onClick={() => removeAlternative()}
                        >
                          Delete
                        </Button>
                      )}
                      <Button
                        color="link"
                        className="pull-right"
                        onClick={() => toggleMainModal()}
                      >
                        Cancel
                      </Button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        {alternative.partnerAlternativeID > 0 && metrics.length > 0 && (
          <Row style={{ marginTop: "30px" }}>
            <Col md="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <div className="h4">Data Item Values</div>
                  {isMetricsLoading && (
                    <Loader style={{}} type="ball-pulse" active />
                  )}
                  {!isMetricsLoading && (
                    <table
                      className="table-responsive"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th width="30%">Metric</th>
                          <th width="50%">Value</th>
                          <th width="20%" />
                        </tr>
                      </thead>
                      <tbody>
                        {metrics.map((m) => {
                          return (
                            <tr key={m.partnerMetricID}>
                              <td>{m.partnerMetricName}</td>
                              {(m.partnerMetricType === "Document" ||
                                m.partnerMetricType === "Image") && (
                                <td>
                                  <a
                                    href={getAlternativeMetricValue(
                                      m.partnerMetricID
                                    )}
                                    target="_blank"
                                  >
                                    {
                                      getAlternativeMetricValue(
                                        m.partnerMetricID
                                      ).split("/")[
                                        getAlternativeMetricValue(
                                          m.partnerMetricID
                                        ).split("/").length - 1
                                      ]
                                    }
                                  </a>
                                </td>
                              )}
                              {m.partnerMetricType !== "Document" &&
                                m.partnerMetricType !== "Image" && (
                                  <td>
                                    {getAlternativeMetricValue(
                                      m.partnerMetricID
                                    )}
                                  </td>
                                )}

                              <td>
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    changeMetric(m);
                                  }}
                                >
                                  Change
                                </a>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </ModalBody>

      <Modal
        size="md"
        isOpen={showModal}
        toggle={() => toggleModal()}
        backdrop="static"
      >
        {metricToEdit !== null && (
          <Fragment>
            <ModalHeader toggle={() => toggleModal()}>
              {metricToEdit.partnerMetricName}
            </ModalHeader>
            <ModalBody>
              <AvForm onSubmit={handleMetricSubmit}>
                <Row>
                  <Col md="12">
                    {metricToEdit.partnerMetricType !== "Address (Map)" && (
                      <AvField
                        name="metricValue"
                        label="Data Item Value"
                        value={metricToEdit.partnerAlternativeMetricValue}
                        onChange={(e) =>
                          setMetricToEdit({
                            ...metricToEdit,
                            partnerAlternativeMetricValue: e.target.value,
                          })
                        }
                        placeholder="Value..."
                      />
                    )}
                    {metricToEdit.partnerMetricType == "Address (Map)" && (
                      <div style={{ marginTop: "10px", marginBottom: "30px" }}>
                        <PlacesAutocomplete
                          debounce={1000}
                          value={address}
                          onChange={handleChange}
                          onSelect={handleSelect}
                        >
                          {({
                            getInputProps,
                            suggestions,
                            getSuggestionItemProps,
                            loading,
                          }) => (
                            <div>
                              <input
                                {...getInputProps({
                                  placeholder: "Search Places ...",
                                  className: "form-control",
                                })}
                              />
                              <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map((suggestion, idx) => {
                                  const className = suggestion.active
                                    ? "suggestion-item--active"
                                    : "suggestion-item";
                                  // inline style for demonstration purpose
                                  const style = suggestion.active
                                    ? {
                                        backgroundColor: "#fafafa",
                                        cursor: "pointer",
                                      }
                                    : {
                                        backgroundColor: "#ffffff",
                                        cursor: "pointer",
                                      };
                                  return (
                                    <div
                                      key={"sug-" + idx}
                                      {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                      })}
                                    >
                                      <span>{suggestion.description}</span>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </PlacesAutocomplete>
                      </div>
                    )}
                  </Col>
                </Row>

                <Button color="link" onClick={() => toggleModal()}>
                  Cancel
                </Button>

                <Button
                  color="primary"
                  type="submit"
                  style={{ marginLeft: ".25rem" }}
                >
                  Save
                </Button>

                {metricToEdit.partnerMetricType === "Document" && (
                  <>
                    <input
                      type="file"
                      ref={hiddenFileInput}
                      onChange={handleInputFileChange}
                      style={{ display: "none" }}
                    />
                    <Button
                      color="primary"
                      style={{ marginLeft: ".25rem" }}
                      onClick={handleUploadFileClick}
                    >
                      Upload File
                    </Button>
                  </>
                )}

                {metricToEdit.partnerMetricType === "Image" && (
                  <>
                    <input
                      type="file"
                      accept="image/*"
                      ref={hiddenFileInput}
                      onChange={handleInputFileChange}
                      style={{ display: "none" }}
                    />
                    <Button
                      color="primary"
                      style={{ marginLeft: ".25rem" }}
                      onClick={handleUploadFileClick}
                    >
                      Upload Image
                    </Button>
                  </>
                )}
              </AvForm>
            </ModalBody>
          </Fragment>
        )}
      </Modal>
    </Modal>
  );
};

export default AlternativeSettings;
